var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 195,
    viewBox: "0 0 166 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.0273 61.0802C82.2714 60.0561 83.7286 60.0561 83.9727 61.0802L88.3645 79.5016C89.6394 84.8493 93.9262 88.9559 99.3237 90.0001L114.925 93.0182C116.005 93.2272 116.005 94.7729 114.925 94.9818L99.3237 97.9999C93.9262 99.0441 89.6394 103.151 88.3645 108.498L83.9727 126.92C83.7286 127.944 82.2714 127.944 82.0273 126.92L77.6355 108.498C76.3606 103.151 72.0738 99.0441 66.6763 98L51.075 94.9818C49.995 94.7729 49.995 93.2272 51.075 93.0182L66.6763 90.0001C72.0738 88.9559 76.3606 84.8493 77.6355 79.5016L82.0273 61.0802Z",
    fill: "url(#paint0_linear_51_1811)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6367 97.5C81.6367 124.39 79.9796 148.712 77.3076 166.293C75.9704 175.091 74.3851 182.156 72.6445 187C71.7722 189.428 70.8818 191.238 70.0019 192.423C69.1035 193.632 68.3642 194 67.8184 194C67.2725 194 66.5324 193.633 65.6338 192.423C64.754 191.238 63.8636 189.428 62.9912 187C61.2506 182.156 59.6653 175.091 58.3281 166.293C55.6561 148.712 53.999 124.39 53.999 97.5C53.999 70.6103 55.6561 46.2876 58.3281 28.707C59.6653 19.9091 61.2506 12.8438 62.9912 8C63.8636 5.57239 64.754 3.76179 65.6338 2.57715C66.5324 1.36725 67.2725 0.999999 67.8184 0.999999C68.3642 1.00018 69.1035 1.36755 70.002 2.57715C70.8818 3.76178 71.7722 5.57236 72.6445 8C74.3851 12.8438 75.9704 19.9091 77.3076 28.707C79.9796 46.2876 81.6367 70.6103 81.6367 97.5Z",
    stroke: "url(#paint1_linear_51_1811)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97.5C84 124.39 85.6571 148.712 88.3291 166.293C89.6663 175.091 91.2516 182.156 92.9922 187C93.8646 189.428 94.7549 191.238 95.6348 192.423C96.5332 193.632 97.2726 194 97.8184 194C98.3642 194 99.1043 193.633 100.003 192.423C100.883 191.238 101.773 189.428 102.646 187C104.386 182.156 105.971 175.091 107.309 166.293C109.981 148.712 111.638 124.39 111.638 97.5C111.638 70.6103 109.981 46.2876 107.309 28.707C105.971 19.9091 104.386 12.8438 102.646 8C101.773 5.57239 100.883 3.76179 100.003 2.57715C99.1043 1.36725 98.3642 0.999999 97.8184 0.999999C97.2725 1.00018 96.5332 1.36755 95.6348 2.57715C94.7549 3.76178 93.8646 5.57236 92.9922 8C91.2516 12.8438 89.6663 19.9091 88.3291 28.707C85.6571 46.2876 84 70.6103 84 97.5Z",
    stroke: "url(#paint2_linear_51_1811)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98C48 119.781 46.659 139.478 44.4971 153.711C43.4149 160.835 42.1329 166.546 40.7295 170.454C40.0257 172.414 39.3117 173.861 38.6152 174.799C37.9 175.762 37.351 176 37 176C36.649 176 36.1 175.762 35.3848 174.799C34.6883 173.861 33.9743 172.414 33.2705 170.454C31.8671 166.546 30.5851 160.835 29.5029 153.711C27.341 139.478 26 119.781 26 98C26 76.2191 27.341 56.5218 29.5029 42.2891C30.5851 35.1649 31.8671 29.4536 33.2705 25.5459C33.9743 23.5862 34.6883 22.1394 35.3848 21.2012C36.1 20.2376 36.649 20 37 20C37.351 20 37.9 20.2376 38.6152 21.2012C39.3117 22.1394 40.0257 23.5862 40.7295 25.5459C42.1329 29.4536 43.4149 35.1649 44.4971 42.2891C46.659 56.5218 48 76.2191 48 98Z",
    stroke: "url(#paint3_linear_51_1811)",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118 98C118 119.781 119.341 139.478 121.503 153.711C122.585 160.835 123.867 166.546 125.271 170.454C125.974 172.414 126.688 173.861 127.385 174.799C128.1 175.762 128.649 176 129 176C129.351 176 129.9 175.762 130.615 174.799C131.312 173.861 132.026 172.414 132.729 170.454C134.133 166.546 135.415 160.835 136.497 153.711C138.659 139.478 140 119.781 140 98C140 76.2191 138.659 56.5218 136.497 42.2891C135.415 35.1649 134.133 29.4536 132.729 25.5459C132.026 23.5862 131.312 22.1394 130.615 21.2012C129.9 20.2376 129.351 20 129 20C128.649 20 128.1 20.2376 127.385 21.2012C126.688 22.1394 125.974 23.5862 125.271 25.5459C123.867 29.4536 122.585 35.1649 121.503 42.2891C119.341 56.5218 118 76.2191 118 98Z",
    stroke: "url(#paint4_linear_51_1811)",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 96.5C14 109.581 13.1623 121.402 11.8154 129.932C11.1408 134.205 10.3452 137.607 9.48242 139.918C9.04902 141.079 8.61965 141.905 8.21972 142.424C7.80475 142.962 7.55757 143 7.5 143C7.44242 143 7.19524 142.962 6.78027 142.424C6.38034 141.905 5.95097 141.079 5.51757 139.918C4.65478 137.607 3.85923 134.205 3.18457 129.932C1.83772 121.402 0.999997 109.581 0.999998 96.5C0.999998 83.4188 1.83773 71.5984 3.18457 63.0684C3.85923 58.7955 4.65478 55.3933 5.51758 53.082C5.95097 51.9211 6.38035 51.0945 6.78027 50.5762C7.19524 50.0384 7.44242 50 7.5 50C7.55758 50 7.80476 50.0384 8.21973 50.5762C8.61965 51.0945 9.04903 51.9211 9.48242 53.082C10.3452 55.3933 11.1408 58.7955 11.8154 63.0684C13.1623 71.5984 14 83.4188 14 96.5Z",
    stroke: "url(#paint5_linear_51_1811)",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152 96.5C152 109.581 152.838 121.402 154.185 129.932C154.859 134.205 155.655 137.607 156.518 139.918C156.951 141.079 157.38 141.905 157.78 142.424C158.195 142.962 158.442 143 158.5 143C158.558 143 158.805 142.962 159.22 142.424C159.62 141.905 160.049 141.079 160.482 139.918C161.345 137.607 162.141 134.205 162.815 129.932C164.162 121.402 165 109.581 165 96.5C165 83.4188 164.162 71.5984 162.815 63.0684C162.141 58.7955 161.345 55.3933 160.482 53.082C160.049 51.9211 159.62 51.0945 159.22 50.5762C158.805 50.0384 158.558 50 158.5 50C158.442 50 158.195 50.0384 157.78 50.5762C157.38 51.0945 156.951 51.9211 156.518 53.082C155.655 55.3933 154.859 58.7955 154.185 63.0684C152.838 71.5984 152 83.4188 152 96.5Z",
    stroke: "url(#paint6_linear_51_1811)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_1811",
    x1: 75.469,
    y1: 94,
    x2: 111.721,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9115BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB8368"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_1811",
    x1: 109.137,
    y1: 99,
    x2: 52.9992,
    y2: 97.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.761428,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9115BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_1811",
    x1: 56.5,
    y1: 99,
    x2: 112.638,
    y2: 97.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.761428,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7657F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_1811",
    x1: 49,
    y1: 98,
    x2: 25,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0102583,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F50D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_1811",
    x1: 117,
    y1: 98,
    x2: 141,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0102583,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B54B94",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_1811",
    x1: 15,
    y1: 96.5,
    x2: -0.00000207629,
    y2: 96.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0102583,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F50D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_1811",
    x1: 151,
    y1: 96.5,
    x2: 166,
    y2: 96.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0102583,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9217BD",
    stopOpacity: 0.16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading_icon.2ed6451d826ea0a89018d7b043567d5c.svg";
export { ForwardRef as ReactComponent };